// Authentication configuration
// Configure the password in your .env file (see .env.example)

export const AUTH_CONFIG = {
  // Password for full access (set REACT_APP_ACCESS_PASSWORD in .env)
  PASSWORD: process.env.REACT_APP_ACCESS_PASSWORD || 'Dynami2024!',
  
  // Whether to require password for demo mode (currently false - demo only needs email)
  REQUIRE_PASSWORD_FOR_DEMO: false,
};


